import {api} from '../../plugins/api'

export default {
    ChargeRenseignements(context, renseignements) {
        return new Promise((resolve, reject) => {
            api.get('renseignementpro/Renseignements?contactId=' + renseignements.contactId + '&typeRp=' + renseignements.typeRp)
                .then(response => {
                    resolve(response.data)
                    context.commit("Renseignement", response.data)
                }).catch(error => console.log(error))
        })
    },
    async EnvoieRenseignements(context) {
        var response = await api.post('renseignementpro/GestionRenseignements',
            {
                listeRenseignementProDTO: context.state.renseignements[0].listeRenseignementProDTO,
                TypeRp: context.state.renseignements[0].typeRp,
                ContactId: context.state.renseignements[0].contactId,
                FormulaireDTO: context.state.renseignements[0].formulaireDTO

            })
        context.commit("Renseignement", response.data)
    },
}